export default "__VITE_ASSET__274b6c82__"